import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

/** flow-schema publishes a consumer per produced type; this block predates that and is untyped. */
const SourceBlockNameSchema = z.object({ sourceBlockName: z.string() }).required();

export const ConsumerOfSchemaWithMessage = (message: string) => {
  return SourceBlockNameSchema.refine((data) => data.sourceBlockName, {
    message,
    path: ['sourceBlockName'],
  });
};

export const HELPER_MESSAGES = {
  documentSource: `Documents extract source block is required.`,
  labValuesSource: `Patient's lab values source block is required.`,
  medicationsSource: `Patient's medications source block is required.`,
  problemsSource: `Patient's conditions source block is required.`,
  proceduresSource: `Patient's surgical history source block is required.`,
};

export const HccAlgorithmBlockConfigSchema = z.object({
  agent: z.string({
    message: 'Agent is required',
  }),
  flowDefinitionIds: z
    .array(z.string({ message: 'Flow definition is required' }))
    .min(1)
    .max(1),
  payload: z.object({
    problems: ConsumerOfSchemaWithMessage(HELPER_MESSAGES.problemsSource),
    documents: ConsumerOfSchemaWithMessage(HELPER_MESSAGES.documentSource),
    labValues: ConsumerOfSchemaWithMessage(HELPER_MESSAGES.labValuesSource),
    medications: ConsumerOfSchemaWithMessage(HELPER_MESSAGES.medicationsSource),
    procedures: ConsumerOfSchemaWithMessage(HELPER_MESSAGES.proceduresSource),
  }),
});
export type HccAlgorithmBlockConfig = z.infer<typeof HccAlgorithmBlockConfigSchema>;

export const HccAlgorithmBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.HCCAlgorithmBlock),
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.HccSkill),
  config: HccAlgorithmBlockConfigSchema,
});
export type HccAlgorithmBlock = z.infer<typeof HccAlgorithmBlockSchema>;
